import { InitSessionResponse } from "Helpers/PaymentService";
import { Action } from "@reactables/core";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearPaymentClientSessionId } from "Helpers/PaymentClientSession";
import { HookedReactable } from "@reactables/react";
import { RxCoverageApplication } from "Features/CoverageApplication/Components/RxCoverageApplication";
import {
  completedOrder,
  errorResponse,
  setInsuredName,
  trackConversion,
  resetApplicationForm,
} from "Actions/actions";
import { CONFIRMATION_ERROR_URL, THANK_YOU_URL } from "Constants/constants";
import PortalOneModalService from "Helpers/PortalOneModalService";

export const usePortalOne = ({
  rxCoverageApplication,
  portalOneModalService,
}: {
  rxCoverageApplication: HookedReactable<typeof RxCoverageApplication>;
  portalOneModalService: PortalOneModalService;
}) => {
  const [, , , actions$] = rxCoverageApplication;
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const rxSubscription = actions$?.subscribe((action) => {
      switch (action.type) {
        case actions$.types["[payment] - [initSessionRequest] - sendSuccess"]: {
          const { payload } = action as Action<InitSessionResponse>;
          portalOneModalService.renderModal(payload);
          break;
        }
        case actions$.types[
          "[payment] - [confirmPaymentRequest] - sendSuccess"
        ]: {
          const { payload } = action;
          const { dashedInsuredName, ...data } = payload;
          dispatch(trackConversion(data));
          dispatch(setInsuredName(dashedInsuredName));
          // Navigate in the background. The One Inc modal container lives
          // on document.body (managed by usePortalOne) and survives this
          // route change, so the user can still use the in-modal receipt /
          // email step while the Thank You page renders underneath.
          history.push(THANK_YOU_URL);
          dispatch(completedOrder(data));
          break;
        }
        case actions$.types[
          "[payment] - [confirmPaymentRequest] - sendFailure"
        ]: {
          const { payload: err } = action;
          dispatch(errorResponse(err));
          dispatch(resetApplicationForm());
          history.push(CONFIRMATION_ERROR_URL);
          setTimeout(() => {
            alert(
              "Your payment was received successfully, however we experienced a technical issue while trying to create your policy. Please call 1-800-310-3351, option 2 for further assistance. We apologize for the inconvenience.",
            );
          }, 500);
          break;
        }
        default:
      }
    });

    const paymentCompleteSub = portalOneModalService.paymentComplete$.subscribe(
      () => {
        clearPaymentClientSessionId();
      },
    );

    return () => {
      portalOneModalService.clearListeners();
      rxSubscription?.unsubscribe();
      paymentCompleteSub.unsubscribe();
    };
  }, [actions$, dispatch, history, portalOneModalService]);
};
